<mat-toolbar class="header">
  <button
    mat-icon-button
    (click)="menuClick.emit()"
    [attr.aria-label]="'header.toggleMenu' | translate"
  >
    <dw-icon icon="tabler:menu-2" [size]="22" />
  </button>

  <span class="header-title">{{ pageTitle.titleKey() | translate }}</span>
  <span class="spacer"></span>

  <button
    mat-icon-button
    [matTooltip]="(theme.mode() === 'dark' ? 'nav.lightMode' : 'nav.darkMode') | translate"
    (click)="theme.toggle()"
  >
    <dw-icon [icon]="theme.mode() === 'dark' ? 'tabler:sun' : 'tabler:moon'" [size]="22" />
  </button>

  <div class="lang-dropdown-wrapper">
    <button class="lang-btn" mat-button (click)="toggleLangMenu($event)">
      {{ language.current() === 'sr-Cyrl' ? 'Српски' : 'Srpski' }}
      <dw-icon [icon]="langMenuOpen() ? 'tabler:chevron-up' : 'tabler:chevron-down'" [size]="14" />
    </button>

    @if (langMenuOpen()) {
      <div class="dropdown">
        @for (lang of languages; track lang.code) {
          <button
            class="dropdown-item"
            [class.active]="language.current() === lang.code"
            (click)="
              $event.stopPropagation(); language.setLanguage(lang.code); langMenuOpen.set(false)
            "
          >
            {{ lang.label }}
          </button>
        }
      </div>
    }
  </div>

  @if (isLoggedIn()) {
    <div class="dropdown-wrapper">
      <button mat-button class="user-btn" (click)="toggleUserMenu($event)">
        <span class="user-avatar">{{ initials() }}</span>
        <span class="user-info">
          <span class="user-name">{{ username() }}</span>
          <span class="user-email">{{ email() }}</span>
        </span>
        <dw-icon
          [icon]="userMenuOpen() ? 'tabler:chevron-up' : 'tabler:chevron-down'"
          [size]="16"
        />
      </button>

      @if (userMenuOpen()) {
        <div class="dropdown">
          <button class="dropdown-item" (click)="navigateToProfile()">
            <dw-icon icon="tabler:user" [size]="18" />
            {{ 'nav.myProfile' | translate }}
          </button>
          <button class="dropdown-item" (click)="$event.stopPropagation(); logout()">
            <dw-icon icon="tabler:logout" [size]="18" />
            {{ 'nav.logout' | translate }}
          </button>
        </div>
      }
    </div>
  } @else {
    <button mat-button (click)="login()">
      <dw-icon icon="tabler:login" [size]="22" />
      {{ 'nav.login' | translate }}
    </button>
  }
</mat-toolbar>
